import script from "./loans-savings-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./loans-savings-report-table.vue?vue&type=script&setup=true&lang=js"

import "./loans-savings-report-table.vue?vue&type=style&index=0&id=80de413a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80de413a"]])

export default __exports__